<template>
  <vx-card title="Kunjungan Hari Ini" v-if="visitorData">
    <div class="w-full">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <div class="font-semibold">Total Antrian</div>
          <div class="py-2 text-lg">{{visitorData.visitor_total}}</div>
        </div>
        <div class="vx-col">
          <feather-icon
            :icon="'UsersIcon'"
            class="p-3 inline-flex rounded-full"
            :class="[`text-primary`]"
            :style="{ background: `rgba(var(--vs-primary),.15)` }"
          ></feather-icon>
        </div>
      </div>
      <div class="my-3" style="border-top: 1px solid #ccc"></div>

      <div class="vx-row">
        <div class="vx-col flex-1">
          <div class="font-semibold">Selesai Dilayani</div>
          <div class="py-2 text-lg">{{visitorData.finished_queue_total}}</div>
        </div>
        <div class="vx-col">
          <feather-icon
            :icon="'CheckIcon'"
            class="p-3 inline-flex rounded-full"
            :class="[`text-primary`]"
            :style="{ background: `rgba(var(--vs-primary),.15)` }"
          ></feather-icon>
        </div>
      </div>

      <div class="my-3" style="border-top: 1px solid #ccc"></div>

      <!-- <div class="vx-row">
        <div class="vx-col flex-1">
          <div class="font-semibold">Antrean Online</div>
          <div class="py-2 text-lg">{{visitorData.online_queue_total}}</div>
        </div>
        <div class="vx-col">
          <feather-icon
            :icon="'SmartphoneIcon'"
            class="p-3 inline-flex rounded-full"
            :class="[`text-primary`]"
            :style="{ background: `rgba(var(--vs-primary),.15)` }"
          ></feather-icon>
        </div>
      </div>
      <div class="my-3" style="border-top: 1px solid #ccc"></div> -->

      <div class="vx-row">
        <div class="vx-col flex-1">
          <div class="font-semibold">Sedang Dilayani</div>
          <div class="py-2 text-lg">{{visitorData.on_service_queue_total}}</div>
        </div>
        <div class="vx-col">
          <feather-icon
            :icon="'UsersIcon'"
            class="p-3 inline-flex rounded-full"
            :class="[`text-primary`]"
            :style="{ background: `rgba(var(--vs-primary),.15)` }"
          ></feather-icon>
        </div>
      </div>
      <div class="my-3" style="border-top: 1px solid #ccc"></div>

      <div class="vx-row">
        <div class="vx-col flex-1">
          <div class="font-semibold">Belum Dipanggil</div>
          <div class="py-2 text-lg">{{visitorData.on_waiting_queue_total}}</div>
        </div>
        <div class="vx-col">
          <feather-icon
            :icon="'UsersIcon'"
            class="p-3 inline-flex rounded-full"
            :class="[`text-primary`]"
            :style="{ background: `rgba(var(--vs-primary),.15)` }"
          ></feather-icon>
        </div>
      </div>

      <div class="my-3" style="border-top: 1px solid #ccc"></div>

      <div class="vx-row">
        <div class="vx-col flex-1">
          <div class="font-semibold">Belum Teregister</div>
          <div class="py-2 text-lg">{{visitorData.not_registered_queue_total}}</div>
        </div>
        <div class="vx-col">
          <feather-icon
            :icon="'UsersIcon'"
            class="p-3 inline-flex rounded-full"
            :class="[`text-primary`]"
            :style="{ background: `rgba(var(--vs-primary),.15)` }"
          ></feather-icon>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    visitorData: {
      required: true,
      type: Object
    }
  }
}
</script>